import React, { Component } from 'react';
import './loading.css';

class Loading extends Component {

    constructor(props){
        super(props)
    }

    render() {
        return (
            <div className={`loading ${this.props.loading === 1 ? '' : 'd-none'}`}>
                <div className="load-9">
                    <div className="spinner">
                        <div className="bubble-1"></div>
                        <div className="bubble-2"></div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Loading

